import { ObjectSchema, string, date, object, TypedForm } from 'libs/form';

export interface BaseActivityFormType {
  activity: {
    id?: string;
    createdAt?: string;
    brightCode?: string;
  };
}
export interface ActivityFormType {
  activity: BaseActivityFormType['activity'] & {
    lastSessionDate?: Date;
    ip?: string;
    userAgent?: string;
  };
}

export const baseActivitySchema: ObjectSchema<BaseActivityFormType> = object({
  activity: object({
    id: string(),
    createdAt: string(),
    brightCode: string(),
  }).default({}),
});

export const activitySchema: ObjectSchema<ActivityFormType> = object({
  activity: object({
    id: string(),
    brightCode: string(),
    createdAt: string(),
    lastSessionDate: date(),
    ip: string(),
    userAgent: string(),
  }).default({}),
});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<ActivityFormType>();
